package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import kotlinx.browser.window
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModel

@Composable
fun RememberWindowSize(): WindowSizeModel {
    val (width, setWidth) = remember { mutableStateOf(window.innerWidth) }
    val (height, setHeight) = remember { mutableStateOf(window.innerHeight) }

    DisposableEffect(Unit) {
        val resizeListener: (dynamic) -> Unit = {
            setWidth(window.innerWidth)
            setHeight(window.innerHeight)
        }

        window.addEventListener("resize", resizeListener)

        onDispose {
            window.removeEventListener("resize", resizeListener)
        }
    }

    return WindowSizeModel(width, height)
}